import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const closeMobileDrawer = () => {
  document.body.classList.remove("sidebar-open");
};

const Layout = () => {
  // Rotary's own mobile drawer also closes on Escape (script.js) — replicated here.
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeMobileDrawer();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="app-layout" style={{ display: "flex", minHeight: "100vh" }}>
      <div id="sidebar-wrapper" className="glass-sidebar">
        {/* existing sidebar content - logic untouched */}
        <Sidebar />
      </div>

      {/* Mobile/tablet dim backdrop behind the sidebar drawer — click to close */}
      <div className="sidebar-backdrop" onClick={closeMobileDrawer}></div>

      <div
        className="main-wrapper"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          minWidth: 0,
        }}
      >
        <div className="glass-header">
          {/* existing navbar/header content - logic untouched */}
          <Navbar />
        </div>

        <div className="glass-panel" style={{ flex: "1 0 auto", margin: "12px 12px 0 12px" }}>
          {/* existing main content / children - logic untouched */}
          <div className="container-fluid flex-grow-1 container-p-y">
            <Outlet />
          </div>
        </div>

        <div className="app-footer-wrap" style={{ margin: "auto 12px 12px 12px", flexShrink: 0 }}>
          {/* existing footer content - logic untouched */}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
